import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.classifications,"label":_vm.$t('Product classification'),"outlined":""},model:{value:(_vm.classification),callback:function ($$v) {_vm.classification=$$v},expression:"classification"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }